var map = {
	"../pages/analytics/analytics.module": [
		818,
		8
	],
	"../pages/gamecode/gamecode.module": [
		816,
		7
	],
	"../pages/loading/loading.module": [
		811,
		6
	],
	"../pages/nextrounds/nextrounds.module": [
		812,
		5
	],
	"../pages/pastscoreboard/pastscoreboard.module": [
		817,
		4
	],
	"../pages/professorlogin/professorlogin.module": [
		813,
		3
	],
	"../pages/reset/reset.module": [
		814,
		2
	],
	"../pages/result/result.module": [
		819,
		1
	],
	"../pages/viewpastornew/viewpastornew.module": [
		815,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 293;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 293
// module chunks = 9